<template>
  <v-container class="py-7">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">{{ page.title }}</span>
            <v-breadcrumbs
              class="app-breadcrumb"
              divider="›"
              :items="dataset.breadcrumbItems"
            ></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn
              id="btnSave"
              type="button"
              elevation="0"
              color="primary"
              dark
              @click="add"
              :loading="dataForm.addLoading"
              v-if="page.isNew && $check(user, ['privacy.create'])"
              >Criar</v-btn
            >
            <v-btn
              id="btnBack"
              type="button"
              elevation="0"
              color="primary"
              outlined
              to="/privacidade"
              >Voltar</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="dataForm.validForm">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-card class="card-form-outlined">
                <v-card-title class="card-group-title">Detalhes</v-card-title>
                <v-card-text>
                  <v-row align-content="center" v-if="!page.isNew">
                    <v-col cols="12" sm="auto" class="pr-0 mr-2" align-self="center">
                      <span>Status:</span>
                    </v-col>
                    <v-col cols="12" sm="2" align-self="center">
                      <v-chip
                        small
                        class="text-uppercase font-weight-bold text-caption"
                        :color="dataset.data.status == 1 ? 'success' : 'error'"
                        label
                        text-color="white"
                      >
                        {{ dataset.data.status == 1 ? 'ATIVO' : 'INATIVO' }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="!page.isNew" cols="12" sm="6">
                      <v-text-field
                        dense
                        label="Versão"
                        v-model="dataset.data.version"
                        outlined
                        hide-details="auto"
                        disabled
                        :class="page.isNew == false ? pl - 0 : null"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" :sm="page.isNew == false ? 6 : 12">
                        <v-text-field dense type="date" label="Prazo de expiração"
                            :value="formatDate(dataset.data.expires_at)" @input="updateEndTerm"
                            outlined hide-details="auto"
                            :disabled="!page.isNew">
                        </v-text-field>
                    </v-col>
                    
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-select
                        style="padding-left: 4px"
                        dense
                        id="user_type"
                        :items="dataset.userType"
                        label="Tipo de usuário"
                        v-model="dataset.data.user_type"
                        item-value="id"
                        item-text="name"
                        outlined
                        hide-details="auto"
                        @change="load"
                        no-data-text="Nenhuma informação disponível"
                        :disabled="!page.isNew"
                        :class="page.isNew == false ? 'pl-0' : null"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        style="padding-left: 4px"
                        dense
                        id="privacy_type"
                        :items="dataset.privacyTypes"
                        label="Tipo de privacidade"
                        v-model="dataset.data.privacy_type"
                        item-value="id"
                        item-text="name"
                        outlined
                        hide-details="auto"
                        @change="load"
                        no-data-text="Nenhuma informação disponível"
                        :disabled="!page.isNew"
                        :class="page.isNew == false ? 'pl-0' : null"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-file-input
                        dense
                        accept="application/pdf"
                        prepend-icon=""
                        outlined
                        counter
                        required
                        show-size="100"
                        :rules="fileRules"
                        hint="O arquivo não pode ser superior a 15MB"
                        hide-details="auto"
                        label="Documento"
                        :clearable="true"
                        @change="onFileSelected($event)"
                        ref="logoFile"
                        :disabled="!page.isNew"
                        truncate-length="100"
                      >
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <template v-if="!page.isNew">
                    <v-row class="mt-n5">
                        <v-col class="doc-info">
                            <span>Documento atual</span>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n3">
                        <v-col>
                            <iframe
                                :src="dataset.resource.file_url"
                                width="250"
                                height="150"
                                frameborder="0"
                                scrolling="no"
                                class="rounded-xl"
                            ></iframe>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                type="button"
                                elevation="0"
                                color="primary"
                                outlined
                                :href="dataset.resource.file_url"
                                target="_blank"
                            >
                                Visualizar termos
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>

              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import string from '@/common/util/string'

import axios from 'axios'

import userType from '@/common/data/term-user-type.data'
import privacyTypes from '@/common/data/privacy-types.data'

export default {
  name: 'PrivacyDetails',

  data: () => ({
    user: null,
    page: {
      isNew: false,
      title: ''
    },
    dataset: {
      userType: [...userType],
      privacyTypes: privacyTypes,
      breadcrumbItems: [],
      data: {
        small_description: '',
        description: '',
      },
      resource: {
        file: null,
        file_url: null,
      }
    },
    dataForm: {
      files: {},
      validForm: true,
      addLoading: false,
      updateLoading: false,
      removeLoading: false,
      created: null
    }
  }),

  created() {
    this.setPage()
    this.listBreadCrumbItems()
    this.load()
  },

  computed: {
       
    fileRules() {
      const rules = []
      if (!this.dataset.data.doc_url) {
        rules.push(this.$rules.required)
      }
      rules.push(this.$rules.fileSize(15))
      return rules
    }
  },

  methods: {
    goBack() {
      this.$router.replace('/privacidade')
    },

    openDoc(doc) {
      this.selectedDoc = doc
      this.dialogViewDoc = true
    },

    setPage() {
      this.page.isNew = this.$route.params.id === 'novo'
      this.page.title = this.page.isNew ? 'Nova privacidade' : 'Detalhes da privacidade'
    },

    onFileSelected(file) {
      this.dataset.data.file = file
    },

    formatDate(date) {
        if (!date || date === "0000-00-00 00:00:00") return null;
        return this.$moment(date).format('YYYY-MM-DD');
    },

    validateExpirationDate(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const selectedDate = new Date(date);
        selectedDate.setHours(0, 0, 0, 0);

        if (selectedDate < today) {
            this.$dialog.notify.error("A data de expiração não pode ser no passado.", {
                position: "top-right",
                timeout: 5000,
            });
            return false;
        }

        return true;
    },


    updateEndTerm(value) {
        this.dataset.data.expires_at = value;
        this.validateExpirationDate(value)
    },

    listBreadCrumbItems() {
      this.dataset.breadcrumbItems = [
        {
          text: 'Homepage',
          disabled: false,
          to: '/home',
          exact: true
        }
      ]

      this.dataset.breadcrumbItems.push({
        text: 'Privacidade',
        disabled: false,
        to: '/privacidade',
        exact: true
      })

      this.dataset.breadcrumbItems.push({
        text: this.page.isNew ? 'Incluir privacidade' : 'Detalhes da privacidade',
        disabled: true,
        exact: true
      })
    },

    async load() {
        this.user = this.$root.user.data || this.$root.user;

        if (this.page.isNew) return;

        if (!this.validateExpirationDate(this.dataset.data.expires_at)) return;

        try {
            const termResult = await axios.get(`/api/admin/terms/${this.$route.params.id}`);
            
            const termData = termResult.data.content;

            this.dataset.data = termData


            const resourceResult = await axios.get(`/api/admin/resources/${this.dataset.data.resource_id}`);

            const resourceData = resourceResult.data.content;

            this.dataset.resource = resourceData

        } catch (error) {
            this.$dialog.notify.error(this.$codes(error), {
                position: "top-right",
                timeout: 2000,
            });
        }
    },


    async uploadFile() {
      const formData = new FormData()
      formData.append('file', this.dataset.data.file)

      try {
        const response = await axios.post('/api/admin/resources', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        this.dataset.data.resource_id = response.data.content.id
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
      }
    },

    async add() {
      if (!this.$refs.form.validate()) return

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja salvar a política?',
        title: 'Incluir política',
        actions: {
          false: 'Cancelar',
          true: 'Salvar'
        }
      })

      if (!proceedAction) return

      this.dataForm.addLoading = true

      await this.uploadFile();

      const payload = this.buildPayload()

      console.log("payload: " + payload)

      try {
        const response = await axios.post('/api/admin/terms', payload)

        this.$dialog.notify.info('Política salva com sucesso!', {
          position: 'top-right',
          timeout: 2000
        })

        this.goBack()
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataForm.addLoading = false
      }
    },

    // async update() {
    //     if (!this.$refs.form.validate()) return;

    //     const proceedAction = await this.$dialog.confirm({
    //         text: 'Deseja atualizar a política?',
    //         title: 'Atualizar política',
    //         actions: {
    //             false: 'Cancelar',
    //             true: 'Atualizar'
    //         }
    //     })

    //     if (!proceedAction) return;

    //     this.dataForm.addLoading = true;

    //     const payload = this.buildPayload();

    //     try {
    //         const response = await axios.patch(`/api/admin/document-models/${this.$route.params.id}`, payload);

    //         this.$dialog.notify.info("Política atualizada com sucesso!", { position: "top-right", timeout: 2000 });

    //         this.goBack()
    //     } catch (error) {
    //         this.$dialog.notify.error(this.$codes(error), {
    //             position: 'top-right',
    //             timeout: 2000
    //         })
    //     } finally {
    //         this.dataForm.addLoading = false;
    //     }
    // },

    

    buildPayload() {
      const formData = new FormData()

      if (this.dataset.data.resource_id) formData.append('resource_id', this.dataset.data.resource_id)

      if (this.dataset.data.user_type) formData.append('user_type', this.dataset.data.user_type)

      if (this.dataset.data.privacy_type) formData.append('privacy_type', this.dataset.data.privacy_type)

      if (this.dataset.data.expires_at) formData.append('expires_at', this.dataset.data.expires_at)

      return formData
    }
  }
}
</script>

<style lang="scss">
.card-group-title {
  text-transform: capitalize;
  font-weight: normal;
  font-size: 22px;
  color: #2c3153;
}

.theme-card {
  .card-section-title {
    color: var(--v-mediumGray-base) !important;
    text-transform: capitalize !important;
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }

  background: var(--v-gray-base) !important;
}

input[type='color'] {
  height: 32px;
  width: 32px;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  cursor: pointer;
}
</style>